<template>
  <div id="vote">
    <div class="fullpage-container">
      <div class="fullpage-wp" v-fullpage="opts" ref="example">
        <section id="vote-1" class="page">
          <div class="section container">
            <div class="title">
              <h1>選舉文化</h1>
              <div class="title_underline"></div>
            </div>
            <div class="section_title animated fadeInLeft">
              漫談台灣選舉文化
            </div>
            <div class="content">
              <p>
                回顧過去至今的選舉文化，1950年代左右，選舉時已經有宣傳車沿街拜票、紅色字樣的「名片型傳單」發送；1970年代，則出現彩色海報、競選歌曲、選戰LOGO及募款餐會等等，更爆發了影響現代民主至深的中壢事件。
              </p>
              <p>
                而在1987年解嚴之後，報紙廣告首先解禁，再來便是電視廣告，至2008年之後則開啟了社群選舉的世代。
              </p>
              <p>
                這些文化在選舉時節無所不在，我們可以認識其時代上的意義，也可再進一步去思考——哪些文化已不適用、哪些文化可與時俱進，也許能共創未來更美好的選舉文化。
              </p>
            </div>
          </div>
        </section>
        <section id="vote-2" class="page">
          <div class="section container">
            <div class="section_title animated">
              助選手法
            </div>
            <div class="sub_title">
              1950年代——競選總部、宣傳車、名片型傳單
            </div>
            <div class="content">
              <p>
                從1950年代開始辦理地方自治選舉以來，候選人在登記參選以後就會成立
                <b-btn v-b-tooltip.hover variant="link" title="（台灣選舉史，頁68）">競選總部</b-btn>
                ，那時候所謂的「競選總部」，其實就是在民房的競選辦事處，候選人的家人也會全家動員，來此打點伙食，充滿
                <b-btn v-b-tooltip.hover variant="link" title="（招治阿嬤的畫《選戰後援部隊》）">濃濃人情味</b-btn>
                。
              </p>
              <img src="../assets/images/vote-1.png" alt="" srcset="../assets/images/vote-1@2x.png 2x" class="img-fluid">
            </div>
          </div>
        </section>
        <section id="vote-3" class="page">
          <div class="section container">
            <div class="content">
              <p>
                當時的宣傳車大多以吉普車為主，掛上寫著候選人姓名字樣的看板便成為宣傳車了，爾後才漸漸加上擴音器及候選人的照片（一開始甚至是手繪的喔!）
                <a href="https://bit.ly/2RyQeV2" target="_blank">（https://bit.ly/2RyQeV2）</a>
              </p>
              <img src="../assets/images/vote-2.png" alt="" srcset="../assets/images/vote-2@2x.png 2x" class="img-fluid">
              <p>
                一開始的競選傳單尺寸較小，也有人說是「名片型傳單」（競選傳播與台灣社會），顏色跟款式也較為單一，大多是黃底紅字搭配一張候選人的照片，簡單寫上參選人姓名及「敬請惠賜一票」而已。
                <a href="https://bit.ly/2r3kY57" target="_blank">（https://bit.ly/2r3kY57）</a>
              </p>
            </div>
          </div>
        </section>
        <section id="vote-4" class="page">
          <div class="section container">
            <div class="sub_title">
              1970年代——彩色海報、競選歌曲、選戰LOGO、募款餐會
            </div>
            <div class="content">
              <img src="../assets/images/vote-3.png" alt="" srcset="../assets/images/vote-3@2x.png 2x" class="img-fluid">
              <p>
                這個時期出現了
                <b-btn v-b-tooltip.hover variant="link" title="（台灣演義：中壢事件 13:14）">彩色海報</b-btn>
                ，為選舉文宣添加新的風貌。
              </p>
              <p>
                而1977年的桃園縣長選舉，更出現了以
                <b-btn v-b-tooltip.hover variant="link" title="（台灣演義：中壢事件 13:46）">「四季春」</b-btn>
                歌謠改編的
                <b-btn v-b-tooltip.hover variant="link" title="（（選戰風雲，頁92）">競選歌曲</b-btn>
                ，搭配宣傳車在路上播送。
              </p>
            </div>
          </div>
        </section>
        <section id="vote-5" class="page">
          <div class="section container">
            <div class="content">
              <p>
                在1978年的增額中央民意代表選舉，黨外入士決定組成「台灣黨外人士助選團」，甚至為此設計了一個Logo
                <a href="https://bit.ly/2FFow7x" target="_blank">（https://bit.ly/2FFow7x）</a>
                ，同時陸續舉辦選前的
                <b-btn v-b-tooltip.hover variant="link" title="（競選傳播與台灣社會，頁25）">募款餐會</b-btn>
                ，選戰的氣氛激烈，可惜在該年美國宣佈與中共建交，此次選舉遂被取消。
              </p>
              <img src="../assets/images/vote-4.png" alt="" srcset="../assets/images/vote-4@2x.png 2x" class="img-fluid">
            </div>
          </div>
        </section>
        <section id="vote-6" class="page">
          <div class="section container">
            <div class="sub_title">
              1980年代至今——報紙廣告、電視廣告、網站、社群互動
            </div>
            <div class="content">
              <p>
                1989年的三項公職人員選舉，首次開放報紙供候選人使用。
              </p>
              <p>
                1991年開放政黨使用電視播送競選文宣後，2000年左右的選舉，電視成為了主要文宣媒體。
              </p>
              <img src="../assets/images/vote-5.png" alt="" srcset="../assets/images/vote-5@2x.png 2x" class="img-fluid">
            </div>
          </div>
        </section>
        <section id="vote-7" class="page">
          <div class="section container">
            <div class="content">
              <p>
                1994年的台北市長選舉，有候選人首次成立了「市政資訊BBS站」，隔年的立委選舉， 各黨依次成立了中央黨部的
                <b-btn v-b-tooltip.hover variant="link" title="（競選傳播與台灣社會，頁59-60）">網站</b-btn>
                ，這也是台灣政黨文宣首次搬上網路。
              </p>
              <img src="../assets/images/vote-6.png" alt="" srcset="../assets/images/vote-6@2x.png 2x" class="img-fluid">
              <p>
                2008年的美國總統大選則開啟了
                <b-btn v-b-tooltip.hover variant="link" title="（Johnson and Perlmutter, 2010）">「臉書選舉」</b-btn>
                時代。至今，台灣的候選人也多會在社群上與選民互動，將廣告放上網路平台， 而2018年也出現了Youtuber參選議員的事例。
              </p>
            </div>
          </div>
        </section>
        <section id="vote-8" class="page">
          <div class="section container">
            <div class="section_title animated">
              作票事件
            </div>
            <div class="content">
              <img src="../assets/images/vote-7.png" alt="" srcset="../assets/images/vote-7@2x.png 2x" class="img-fluid">
              <p>
                《選舉萬歲》一書中說道，作票是「一種以組織力量和強制力量，壟斷性地否決經由投票所表現出來的民眾意願的行為」。
              </p>
              <p>
                在台灣選舉史上，曾經發生不少「作票」引發的事件，最有名的莫過於1977年的中壢事件。那個年代對選舉弊端的不滿只能透過抗爭來表達，事件的發生同時也表露出人民對選舉、法院、警察體系的不信任，我們可以一起認識這些過去，同時反思現在的民主。
              </p>
            </div>
          </div>
        </section>
        <section id="vote-9" class="page">
          <div class="section container">
            <div class="sub_title">
              1975年的宜蘭事件
            </div>
            <div class="content">
              <p>
                1975年郭雨新參選增額立委選舉，在他落選後不久，挖馬路工人無意間挖出一大袋、數萬張投給郭雨新的「廢票」，此事情引起兩萬宜蘭人民憤而包圍縣政府，這些人爾後被郭雨新勸回，避免了一場大規模的暴動。
              </p>
              <img src="../assets/images/vote-8.png" alt="" srcset="../assets/images/vote-8@2x.png 2x" class="img-fluid">
              <p>
                而姚嘉文、林義雄兩位律師於選舉後為郭雨新提起「選舉無效之訴」，但法官判決敗訴，而他們兩人將這次經過寫成《虎落平陽－選戰!官司!郭雨新》一書。
              </p>
            </div>
          </div>
        </section>
        <section id="vote-10" class="page">
          <div class="section container">
            <div class="sub_title">
              1977年的古坑事件
            </div>
            <div class="content">
              <img src="../assets/images/vote-9.png" alt="" srcset="../assets/images/vote-9@2x.png 2x" class="img-fluid">
              <p>
                1977 年縣長選舉，除了中壢事件外，另外發生了「古坑事件」。
              </p>
              <p>
                雲林縣因黨外代表組成聯合陣線，激起國民黨高度危機感，而縣長候選人國民黨提名林恆生與黨外的黃蔴對陣。
              </p>
              <p>
                投票當天，古坑鄉發生疑似作票的行為，引爆鄉民聚眾抗議，最後由黃蔴出面安撫群眾情緒，並保證一定會打官司追究到底。雖然事後由姚嘉文及林義雄兩位律師幫他打選舉官司，還是無法改變落選的事實。
              </p>
            </div>
          </div>
        </section>
        <section id="vote-11" class="page">
          <div class="section container">
            <div class="sub_title">
              1992年的第二屆立委選舉
            </div>
            <div class="content">
              <p>
                1992年黃信介參選花蓮縣立委選舉以62票些微差距落選，由於指證歷歷，更有大批民眾前往花蓮縣府抗議，驗票之下，發現竟有12個投票所共多出738張幽靈選票，比投票人數還多。
              </p>
              <p>
                於是檢方查出多位選務人員用預藏的選票，趁著整理清點、其他監票人員不注意時，暗中投入票匭。最後共起訴了27人，由中選會公告黃信介當選。
              </p>
              <p>
                這也是台灣選舉史上少數付諸司法而成功的案例。
              </p>
              <img src="../assets/images/vote-10.png" alt="" srcset="../assets/images/vote-10@2x.png 2x" class="img-fluid">
            </div>
          </div>
        </section>
      </div>
      <div class="pager">
        <a href="javascript:void(0);"
           v-for="btn in pageNum"
           :class="{active:index == btn - 1}"
           @click="moveTo(btn - 1)">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Vote',
    mounted: function () {
      this.$root.title = '選舉文化';
    },
    data: function () {
      let self = this;

      return {
        index: 0,
        pageNum: 11,
        opts: {
          start: 0,
          beforeChange: function (ele, current, next) {
            self.index = next;
          },
          afterChange: function (ele, current) {
            self.index = current;
            $('.section_title').removeClass('fadeInLeft');
            $(ele).find('.section_title').addClass('fadeInLeft');
          },
        }
      }
    },
    methods: {
      moveTo: function (index) {
        this.$refs.example.$fullpage.moveTo(index, true);
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/css/global";

  #vote {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    h1 {
      width: 100%;
      background: url("../assets/vote.svg") center center no-repeat;
      text-indent: 200%;
      overflow: hidden;
      white-space: nowrap;

      @include media-breakpoint-down(sm) {
        background-position: left center;
      }
    }

    .content {
      button {
        border-radius: 0;
        border: none;
        padding: 0;
        vertical-align: baseline;
      }
    }
  }
</style>
